import styled, { css } from 'styled-components'
import Color from 'color'

import DefaultButton from './DefaultButton'
import { ButtonProps } from './types'

interface CancelProps extends ButtonProps {
  breakOnMobile?: boolean
  vertical?: boolean
  basic?: boolean
}

// @ts-ignore
const CancelButton = styled(DefaultButton)<CancelProps>`
  ${({ theme, basic }) => css`
    &&&:not(.green) {
      border: 0;
      color: #012d3e;
      background: ${!basic ? theme.colors.lightGrey : 'none'} !important;
      padding: 0.75em 2em !important;
      height: 38px !important;
      line-height: 17px;

      :hover {
        color: #012d3e !important;
        background: ${!basic
          ? Color(theme.colors.lightGrey).darken(0.05).string()
          : 'none'} !important;

        > i.icon {
          color: #012d3e !important;
        }
      }
    }
  `}
`

export default CancelButton
